import styled, { css } from 'styled-components';

const MobileProgressStyled = styled.div.attrs({
  className: 'mobile-progress',
})`
  ${({ theme, c2fEnabled }) => {
    const { colors } = theme;
    return css`
      display: flex;
      align-items: center;
      padding: 24px;
      background-color: ${colors.primary.white};
      overflow: hidden;

      .mobile-progress {
        &__step {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          min-width: 0;
          border: none;
          background: none;

          &--active .mobile-progress__line {
            background-color: ${colors.primary.gravity};
          }

          &--active .mobile-progress__label {
            color: ${colors.primary.gravity};
          }

          &--inactive .mobile-progress__line {
            background-color: ${colors.secondary.pumice};
          }

          &--inactive .mobile-progress__label {
            color: ${colors.secondary.pumice};
          }
        }

        &__line {
          width: ${c2fEnabled ? '90%' : '75.7px'};
          height: 2px;
          border-radius: 2px;
          margin-bottom: 8px;
        }

        &__label {
          font-size: 14px;
          font-weight: 700;
          text-align: center;
          line-height: 20px;
          letter-spacing: 0px;
        }
      }
    `;
  }}
`;

export default MobileProgressStyled;
